@import 'style/fonts.css';

body {
  position: relative;
  margin: 0;
  padding: 0;
  /* overflow: hidden; */
  background: var(--background-color);

  // use satoshi variable font
  font-family: 'Satoshi Variable', sans-serif;
}

body[data-theme='light'] {
  --accent-color: #dfd671;
  --background-color: #f0f0f0;
  --hexagon-color: #ececec;
  --inverse-background-color: #1e1e1e;
}
body[data-theme='dark'] {
  --accent-color: #94df71;
  --background-color: #1e1e1e;
  --hexagon-color: #ececec;
  --inverse-background-color: #f0f0f0;
}

canvas {
  display: block;
  position: fixed;
  z-index: -1;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 0;
  background: linear-gradient(180deg, var(--background-color) 0%, transparent 15%, var(--background-color) 90%);

  &--dim {
    background: linear-gradient(
      180deg,
      var(--background-color) 0%,
      rgba(from var(--background-color) r g b / 0.75) 15%,
      var(--background-color) 90%
    );
  }
}

main {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0rem;
  padding: 0rem;
}

@media screen and (min-width: 960px) {
  main {
    margin: 0rem;
    padding: 0rem;
  }

  section {
    max-width: 80%;
    margin: 0rem;
    padding: 0rem;
  }
}

@media screen and (min-width: 1280px) {
  section {
    max-width: 50%;
  }
}

.section {
  display: flex;
}

.section > .panel {
  --background-color: rgba(40, 40, 40, 0.6);

  width: calc(100vw - 3rem);
  height: calc(100vh - 10rem);
  margin: 0.5rem;
  padding: 1rem;

  background: var(--background-color);
  box-shadow: 0 4px 30px rgba(30 30 30 / 0.6);
  backdrop-filter: blur(9.3px);
  -webkit-backdrop-filter: blur(9.3px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 0.5rem;
  color: white;
}

.section--home > .panel {
  width: auto;
  height: auto;
  align-self: center;
}

@media screen and (min-width: 768px) {
  .section > .panel {
    width: calc(50vw - 4rem);
    margin: 2rem;
    padding: 2rem;
  }

  .section--home > .panel {
    width: calc(50vw - 6rem);
    height: auto;
    align-self: center;
  }

  .section--contact > .panel {
    width: calc(50vw - 6rem);
  }

  .section--info > .panel {
    min-width: calc(100vw - 8rem);
  }
}

h1 {
  font-size: 3rem;
  margin: 0 0 1rem 0;
}
h2 {
  font-size: 1.6rem;
}
p {
  font-size: 1.2rem;
  line-height: 1.8;
}
